/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.17",
    versionName: "0.4.0-nightly.2026.7.17",
    versionChannel: "nightly",
    buildDate: "2026-07-17T00:29:30.347Z",
    commitHash: "6b08f4e52b6d3f71981034e17b5bff6b37bde6de",
};
